import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFilter',
  standalone: true,
})
export class PhoneFilterPipe implements PipeTransform {
  transform(phone: string): string {
    // Remove "(0)" and "-" characters
    return phone?.replace('(0)', '').replace(/-/g, '').replace(/\s/g, '');
  }
}
